import Vue from 'vue';
import {WALLET_TYPES} from "../common/constant";

Vue.filter('wallets', value => {
    if(!value) return '';
    return WALLET_TYPES[value];
});
